import Brain from '../../assets/PharmTrix Brain.svg'
import Handshake from '../../assets/Pharm Trix Partnership.svg'
import Pill from '../../assets/Pharm Trix Pill.svg'
import Chart from '../../assets/Pharm Trix Chart.svg'

const data = [
    {img: Brain,title:'PharmtriX: Elevating Pharmacy Operations',description:'PharmtriX empowers you to take control of your pharmacy operations. It is an integrated software solution, used in Whole,Retail, as well as hospital outpatient and inpatient pharmacies.'},
    {img: Pill,title:'Driving Efficiency and Insight in Pharmacy Operations: Our Solutions, Your Success',description:'Our solutions enable you to reduce costs and errors, improve efficiency and gain valuable insights into your pharmacy operations and returns.'},
    {img: Handshake,title:'Efficient Prescription Handling in Retail Pharmacies with Integration',description:'This integration provides a dependable, repeatable process for dispensing and checking prescription orders in the retail pharmacy.'},
    {img: Chart ,title:'Expert Partnerships, Optimal Pharmacy Performance',description:'Additionally, our team of experts will partner with you to optimize your pharmacy activities so you can focus on providing excellent care to your customers and patients'}
    

]


export default function MissionCard () {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mx-auto max-w-[85%] my-10 ">
            {data.map((datum, index) => (
                <Card 
                    key={index} 
                    img={datum.img} 
                    title={datum.title} 
                    description={datum.description} 
                />
            ))}
        </div>
    );
}


function Card({img,title,description}) {
    return (
        <div className='grid  grid-cols-1 md:grid-cols-[auto_1fr] text-center md:text-left place-items-center '>
        <img src={img} className='w-12 h-12 object-contain my-auto' alt={title}/>
        <div className='mx-2'>
            <h2 className='font-bold text-base md:text-xl'>{title}</h2>
            <p className='text-sm md:text-base text-gray-800'>{description}</p>
        </div>
        <div className='w-[2rem] border-b-2 border-blue-400 md:hidden mt-5'>

        </div>
    </div>
    )
}